import React from 'react';
import { Grid, useTheme, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { CardWeekHeader, DayCardActionGroup, DayCardAssignmentContent } from '.';
import { LessonsPlanLesson, LessonPlanSection } from 'state/modules/entity/types';
import { useSelector, shallowEqual } from 'react-redux';
import { AppStoreState } from 'types';
import { formatUiDate } from 'util/date-util';

type Props = {
  lessons: Array<LessonsPlanLesson>;
  lessonSections?: Array<LessonPlanSection>;
};
export const DayCardFullSize: React.FC<Props> = ({ lessons, ...props }) => {
  const { currentDay } = useSelector(
    ({ lessonPlanner }: AppStoreState) => lessonPlanner,
    shallowEqual
  );

  const theme = useTheme();
  const classes = useStyles(theme)({
    hasLesson: lessons[currentDay]?.lessons && lessons[currentDay]?.lessons[0] ? false : true
  });

  const getCurrentLesson = currentDay =>
    lessons[currentDay]?.lessons ? lessons[currentDay]?.lessons[0] : null;
  return (
    <Grid>
      <CardWeekHeader
        day={lessons[currentDay]?.dayOfWeek ?? ''}
        date={formatUiDate(lessons[currentDay].lessonDate as any)}
        className={classes.cardWeekTitle}
        headerClasses={classes}
      />
      <Paper elevation={2} {...props} className={classes.card}>
        <DayCardAssignmentContent
          lesson={getCurrentLesson(currentDay) as any}
          classes={classes}
          styleOverride={{ marginLeft: 6 }}
          lessonDate={lessons[currentDay]?.lessonDate ?? ''}
          dragIndices={undefined}
          readonly={false}
        />
        <div className={classes.actionGroupContainer}>
          <DayCardActionGroup
            className={classes.buttonGroup}
            handleAssignLesson={() => null}
            disabled={!lessons[currentDay]?.lessonDate}
          />
        </div>
      </Paper>
    </Grid>
  );
};

const useStyles = theme =>
  makeStyles({
    cardWeekTitle: {
      display: 'flex',
      flex: 1,
      marginTop: '43px',
      marginBottom: '10px'
    },
    card: ({ hasLesson }: any) => ({
      ...(hasLesson
        ? {
            display: 'flex',
            flexDirection: 'column'
          }
        : {}),
      height: 385,
      padding: 4,
      margin: 0,
      marginTop: 4
    }),

    cardBody: {
      height: 385,
      fontFamily: theme.typography.fontFamily,
      fontSize: 12,
      fontWeight: 200,
      lineHeight: '24px',
      margin: 6
    },
    buttonGroup: ({ hasLesson }: any) => ({
      display: 'flex',
      flex: 0.35,
      flexDirection: 'row-reverse',
      justifyContent: 'space-between',
      margin: 10,
      ...(hasLesson
        ? {
            alignSelf: 'flex-end'
          }
        : {})
    }),
    titleRow: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginRight: 26
    },
    button: {
      cursor: 'pointer',
      fontWeight: 400
    },
    dayCardAssignment: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      border: '1px solid #A6A6A6',
      borderRadius: 4,
      margin: 0,
      fontSize: '18px',
      width: '64vw',
      maxWidth: 1034,
      height: 308
    },
    actionGroupContainer: {
      display: 'flex',
      flex: 1,
      justifyContent: 'flex-end'
    },
    dateClass: {
      marginLeft: 24,
      alignSelf: 'center'
    }
  });
